/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryStatistics
 */
export interface CategoryStatistics {
    /**
     * 
     * @type {string}
     * @memberof CategoryStatistics
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryStatistics
     */
    categoryName?: string;
    /**
     * 
     * @type {number}
     * @memberof CategoryStatistics
     */
    teamsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryStatistics
     */
    matchesCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryStatistics
     */
    totalGoals?: number;
}

/**
 * Check if a given object implements the CategoryStatistics interface.
 */
export function instanceOfCategoryStatistics(value: object): value is CategoryStatistics {
    return true;
}

export function CategoryStatisticsFromJSON(json: any): CategoryStatistics {
    return CategoryStatisticsFromJSONTyped(json, false);
}

export function CategoryStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'categoryName': json['categoryName'] == null ? undefined : json['categoryName'],
        'teamsCount': json['teamsCount'] == null ? undefined : json['teamsCount'],
        'matchesCount': json['matchesCount'] == null ? undefined : json['matchesCount'],
        'totalGoals': json['totalGoals'] == null ? undefined : json['totalGoals'],
    };
}

export function CategoryStatisticsToJSON(json: any): CategoryStatistics {
    return CategoryStatisticsToJSONTyped(json, false);
}

export function CategoryStatisticsToJSONTyped(value?: CategoryStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryId': value['categoryId'],
        'categoryName': value['categoryName'],
        'teamsCount': value['teamsCount'],
        'matchesCount': value['matchesCount'],
        'totalGoals': value['totalGoals'],
    };
}

